import React from "react";
import { useSelector } from "react-redux";
import { getProfileSettings } from "features/authSlice";
import ProfileSettings from "pages/dashboard/v2/shared/profile-settings/ProfileSettings";
import "./shellProfileOverlay.scss";

export interface ShellProfileOverlayProps {
  /** Underlying page/tab content restored when profile closes. */
  readonly children: React.ReactNode;
}

/**
 * Unified in-shell profile settings surface for any GlobalNavigationShell /
 * SharedLayout route. Renders ProfileSettings as main content (not a modal or
 * layout swap) when auth.showProfile is true; otherwise renders children.
 */
const ShellProfileOverlay: React.FC<ShellProfileOverlayProps> = ({ children }) => {
  const showProfile = useSelector(getProfileSettings);

  if (!showProfile) {
    return <>{children}</>;
  }

  return (
    <div className="shell-profile-overlay" data-testid="shell-profile-overlay">
      <ProfileSettings />
    </div>
  );
};

export default ShellProfileOverlay;
